export default "__VITE_ASSET__Ba4JCmjC__"